var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(-1220 -205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32_copy_2",
    "data-name": "Rectangle 32 copy 2",
    width: 28,
    height: 28,
    rx: 8,
    transform: "translate(1220 205)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1083.333 68.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_38",
    d: "M154.974,146.363a1.05,1.05,0,0,1,0,1.487l-2.823,2.819,2.823,2.823a1.051,1.051,0,0,1-1.487,1.487l-2.819-2.823-2.823,2.823a1.051,1.051,0,1,1-1.487-1.487l2.823-2.823-2.823-2.823a1.051,1.051,0,0,1,1.487-1.487l2.823,2.823,2.823-2.823A1.048,1.048,0,0,1,154.974,146.363Z",
    fill: "#2b2b2b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.41d3f55361b7943ab55c9541fb7eda3d.svg";
export { ForwardRef as ReactComponent };